import { defaultsDeep } from 'lodash';

export default defaultsDeep(window.__env_conf);
